import { multiAttempt } from "shared/functions";

export class ReadaloudAudioStorageService {

	private waiting: number = 0;

	constructor(
		private readonly storeEndpoint: string,
		private readonly deleteEndpoint: string,
		private readonly formFilename?: string,
	) { }

	public async storeAudio(blob: Blob, attempts: number = 3): Promise<string> {
		const formData = new FormData();
		formData.append("audio_data", blob, this.formFilename);

		this.waiting++;
		try {
			return await multiAttempt(attempts, async () => {
				const response = await fetch(this.storeEndpoint, {
					method:      "POST",
					body:        formData,
					credentials: "include"
				});
				const data = await response.json();
				return data.filename as string;
			});
		} finally {
			this.waiting--;
		}
	}

	public isBusy(): boolean {
		return this.waiting > 0;
	}

	public async deleteAudio(filenames: string[]): Promise<void> {
		if (filenames.length === 0) {
			return;
		}
		await fetch(this.deleteEndpoint, {
			method:      "POST",
			body:        JSON.stringify({ filenames }),
			credentials: "include"
		});
	}
}
